var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-component",class:[_vm.type, _vm.variant]},[_c('p',{staticClass:"banner-text-content"},[_vm._t("banner-text")],2),_vm._v(" "),_c('button',{staticClass:"action-button",on:{"click":_vm.bannerClicked}},[_vm._t("banner-action")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }